import { render, staticRenderFns } from "./SupplementReviewList.vue?vue&type=template&id=18f0fae3&scoped=true&"
import script from "./SupplementReviewList.vue?vue&type=script&lang=js&"
export * from "./SupplementReviewList.vue?vue&type=script&lang=js&"
import style0 from "./SupplementReviewList.vue?vue&type=style&index=0&id=18f0fae3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f0fae3",
  null
  
)

export default component.exports